import type { ReactNode } from 'react';
import type { DeleteableProject } from '@frameio/shared/resources';
import { useDeleteProjects } from '@frameio/shared/resources';
import { useUploaderWorker } from '@frameio/transfers/hooks';
import { useRemoveRecentProjects } from '../../shared';

export type UseDeleteProjectConfirmationModalReturn = {
  deleteProjectModal: ReactNode;
  showDeleteProjectConfirmationModal: (projects: DeleteableProject[]) => void;
};

type Opts = {
  onSuccess?: () => void;
};

export const useDeleteProjectConfirmationModal = (
  opts?: Opts
): UseDeleteProjectConfirmationModalReturn => {
  const uploaderWorker = useUploaderWorker();
  const removeRecentProjects = useRemoveRecentProjects();
  const { deleteDialog, showDeleteConfirmation } = useDeleteProjects(
    uploaderWorker,
    {
      trackingSource: 'Workspace',
      onSuccess: (projects) => {
        const projectIds = projects.map((project) => project.id);
        removeRecentProjects(projectIds);
        opts?.onSuccess?.();
      },
    }
  );

  return {
    deleteProjectModal: deleteDialog,
    showDeleteProjectConfirmationModal: showDeleteConfirmation,
  };
};
